import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CargadorTcPage } from './cargador-tc';
// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
@NgModule({
  declarations: [
    CargadorTcPage,
  ],
  imports: [
    IonicPageModule.forChild(CargadorTcPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }),
  ],
})
export class CargadorTcPageModule {}



// WEBPACK FOOTER //
// ./src/pages/team-challenge/cargador-tc/cargador-tc.module.ts